import BaseAPI from "../api";

const path: string = "/edpex-standard-point-detail";

export type listType = {
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class edpexStandardPointDetailMasterAPI extends BaseAPI {
  static getEdpexStandardPointDetailMasterList(query?: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static createEdpexStandardPointDetailMaster(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static updateEdpexStandardPointDetailMaster(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteEdpexStandardPointDetailMaster(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }
}
